<script>
  export let item
  export let base
</script>

<div class="row no-gutters pos-rel">

  <div class="pos-abs text-white p-4 ml-2">
    {#if item.title}{item.title}{:else}Lightyears Away.{/if}
  </div>
  {#if item.images[0]}
    <img src={item.images[0].url} class="img-fluid img-full" alt="banner" />
  {:else if item.image}
    <img src={item.image} class="img-fluid" alt="right" />
  {:else}
    <img
      src="{base}themes/PlayFair/img/milkyway.jpg"
      class="img-fluid img-full"
      alt="banner" />
  {/if}

</div>
